import React from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { InputField } from '@/components/molecules/input-field'
import { useTerminalSetting } from '@/hooks/self-checkin-device-settings/use-terminal-setting'
import { modalDeviceFormStyle, modalDeviceInputStyle } from './modal-form-styles'
import { DeviceSettingsModalFrame, DeviceSettingsModalNavigationProps } from './modal-frame'

type Props = DeviceSettingsModalNavigationProps & {
  hotelId: string
}

export const TerminalDeviceSettingsPanel: React.FC<Props> = props => {
  const { t } = useTranslation()
  const { control, isDirty, isLoading, canTestConnection, testConnection, save, cancel } = useTerminalSetting(props.hotelId)

  return (
    <DeviceSettingsModalFrame
      {...props}
      isLoading={isLoading}
      isDirty={isDirty}
      onCancel={cancel}
      onSave={save}
      connectionTest={{ onTest: testConnection, isDisabled: !canTestConnection }}
    >
      <div css={modalDeviceFormStyle}>
        <div className="input-container">
          <div className="input-label">{t('IP Address of terminal')}</div>
          <Controller
            control={control}
            name="terminalIp"
            render={({ field: { onChange, value } }) => (
              <InputField
                value={value}
                marginBottom={0}
                customInputStyle={modalDeviceInputStyle}
                handleChangeData={onChange}
                placeholder="127.0.0.1"
              />
            )}
          />
        </div>
        <div className="input-container">
          <div className="input-label">{t('Port of terminal')}</div>
          <Controller
            control={control}
            name="terminalPort"
            render={({ field: { onChange, value } }) => (
              <InputField
                value={value}
                marginBottom={0}
                customInputStyle={modalDeviceInputStyle}
                handleChangeData={onChange}
                placeholder="3647"
              />
            )}
          />
        </div>
      </div>
    </DeviceSettingsModalFrame>
  )
}
